module.exports = __webpack_public_path__ + "fonts/subset-TitilliumWeb-Bold.43c980ab.ttf";